/**
 * Fixes blog post grids.
 */

( function( $ ) {

    const className = 'js-archive-taxonomy-dropdowns';
    const selector = `.${className}`;
    const fieldSelector = `${selector}__field`;
    const dropdownSelector = `${selector}__dropdown`;

    const archiveDataAttr = 'archive';
    const taxQueryParamDataAttr = 'taxonomy-query-param';

    function prependURL( url ) {

        if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
            url = 'http://' + url;
        }
        return url;
    }

    $( window ).load( function() {

        $( dropdownSelector ).on( 'change', function( event ) {

            const target = $( event.target );

            const element = target.closest( selector );
            const fields = element.find( fieldSelector );

            let builtURL = new URL( prependURL( element.data( archiveDataAttr ) ) );

            fields.each( function( i, field ) {

                field = $( field );
                const tax = field.data( taxQueryParamDataAttr );
                const term = field.find( dropdownSelector ).val();

                if ( term !== '0' ) {
                    builtURL.searchParams.append( tax, term );
                }
            } );

            window.location.href = builtURL.toString();
        } );

    } );
    
} )( jQuery );